import type { Unit } from './types';

export const UNIT_TO_MS: Record<Unit, number> = {
  seconds: 1_000,
  minutes: 60_000,
  hours: 3_600_000,
  days: 86_400_000
};
